import { render } from "./Widget13.vue?vue&type=template&id=70041eb4"
import script from "./Widget13.vue?vue&type=script&lang=ts"
export * from "./Widget13.vue?vue&type=script&lang=ts"
script.render = render

export default script